import { render, staticRenderFns } from "./ticketWalletTransList.vue?vue&type=template&id=6c269150&lang=pug"
import script from "./ticketWalletTransList.vue?vue&type=script&lang=js"
export * from "./ticketWalletTransList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports